import { IStores } from "./index";
import * as services from "services";
import { ListStoreConstructor } from "./ListStoreConstructor";
import { ContractOnCompany } from "interfaces";

export class CompanyContractList extends ListStoreConstructor<ContractOnCompany> {
  id: string = "";

  setId(id: string) {
    this.id = id;
  }

  constructor(stores: IStores) {
    super(
      stores,
      (params) => {
        const paramsWithSort = {
          ...params,
          sort: ["statusDate,desc"],
        };
        return services.getCompanyContractList({ companyId: this.id }, paramsWithSort).then(
          (response) =>
            ({
              content: response.content || [],
              size: response.size || 0,
              totalPages: response.totalPages || 0,
              totalElements: response.totalElements || 0,
            }) as any
        );
      },
      {
        pollingInterval: 10000,
      }
    );
  }
}
